import React from 'react'
import styled from 'styled-components'
import {default as Form} from './Form/Form.js'
import {default as logo} from '../../assets/logo1.gif'
import {default as logo1} from '../../assets/nav-bharat-engineering-works-logo-90x90.png'
import {default as logo2} from '../../assets/logo-light.webp'

const Footer = () => {

  return (
    <FooterSection id="ContactSection" >
      <FormSection>
       <Form />
      </FormSection>
      <CollabSection>
        <CollabHeading>Our Collaborative Effort</CollabHeading>
        <Partners>
          <PartnerImage src={logo} />
          <PartnerImage2 src={logo1} />
          <PartnerImage src={logo2} />
        </Partners>
        <Span>and many more.....</Span>
      </CollabSection>
      <ContactSection>
        <Address>Punjab Expeller Compound, 47, near Sihani Chungi, Ghaziabad, Uttar Pradesh 201003</Address>
        <PhoneNumber>+91-8130812805</PhoneNumber>
        <PhoneNumber>+91-9266531452</PhoneNumber>
        <Note>For inquiries, questions, or commendations, feel free to contact us using the form below. Our dedicated team is ready to assist you promptly.</Note>
      </ContactSection>
      <MapSection>
        <iframe width="85%" height="500" frameborder="0" scrolling="no" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Sree%20Ram%20Engineering,%20Punjab%20Expeller%20Compound,%2047,%20near%20Sihani%20Chungi,%20Ghaziabad,%20Uttar%20Pradesh%20201003+(Sree%20Ram%20Engineering)&amp;t=h&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.maps.ie/population/">Population calculator map</a></iframe>
      </MapSection>
    </FooterSection>
  )
}

export default Footer



const FooterSection = styled.div`
  width: 100%;
  margin-left: 7.5rem;
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  grid-template-rows: 1fr 1fr; 

  @media(max-width: 1150px){
    grid-template-columns: 1fr ;
  grid-template-rows: 1fr; 
  }

  @media (max-width: 700px){
      margin-left: 0;
      margin-right: 0;
  }

`

const FormSection = styled.div`
  background: #000;

  padding: 5rem 5rem 2.5rem 5rem;

  @media(max-width: 1150px){
    padding: 7.5rem;
    width: 100%;
  }
`

const CollabSection = styled.div`
  background: #F2B705;

  padding: 2.5rem 5rem 2.5rem 5rem;

  display: flex;
  flex-direction: column;
  gap: 2.5rem;
`

const CollabHeading = styled.h1`
  color: #000;
  font-family: var(--font-primary);
  font-size: 4.5rem;
  font-weight: 600;
  width: 60%;

  @media (max-width: 950px){
    width: 100%;
  }
  
`

const Partners = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 2.5rem;
`

const PartnerImage = styled.img`
  width: 17.5rem;
  height: 5.5rem;
`

const PartnerImage2 = styled.img`
  width: 9.5rem;
  height: 5.5rem;
`

const Span = styled.span`
  color: #000;
  font-family: var(--font-primary);
  font-size: 1.75rem;
  font-weight: 600;
`

const MapSection = styled.div`
  background: #000;
  padding: 1rem 2.5rem 0rem 0rem;
  display: flex;
  justify-content: start;
  align-items: center;

  @media(max-width: 1150px){
    padding: 2.5rem;
  }

`

const ContactSection = styled.div`
  background: #000;

  padding: 7.5rem 5rem 0rem 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;

  @media(max-width: 1150px){
    padding: 2.5rem;
  }
`

const Address = styled.div`
  color: #FFF;
  font-family: var(--font-primary);
  font-size: 1.75rem;
  font-weight: 300;
  width: 90%;
`

const PhoneNumber = styled.button`
  color: #F2B705;
  text-align: center;
  font-family: var(--font-primary);
  font-size: 2.3rem;
  padding: 1rem;
  background: #FFF;
  border: none;
  outline: none;
  border-radius: 10rem;
  cursor: pointer;
  width: 80%;

  @media(max-width: 1200px){
      font-size: 2rem;
      width: 70%;
  }

`

const Note = styled.div`
  color: #FFF;
  font-family: var(--font-primary);
  font-size: 1.2rem;
  font-weight: 300;
  width: 90%;
`